import { Store } from './store';
export default {
  install(Vue, options) {
    // "can" directive accept string with single permission or object containing "permission", and "authorId"
    Vue.directive('can', {
      inserted (el, binding, vnode, oldVnode) {
        let permission = binding.value;
        let hasPermission = Store.getters['currentUser/hasPermission'](permission);
        console.log(permission, hasPermission);

        if (!hasPermission) {
          if (binding.arg === undefined) {
            vnode.elm.parentNode.removeChild(vnode.elm);
          }

          if (binding.arg === 'disabled') {
            vnode.elm.setAttribute('disabled', true);
          }
        }

      }
    });

    Vue.directive('can-any', {
      inserted (el, binding, vnode, oldVnode) {
        let permissions = binding.value;
        let result = false;
        permissions.forEach((permission) => {
          let hasPermission = Store.getters['currentUser/hasPermission'](permission);
          result = result || hasPermission;
        })
        if (!result) {
          if (binding.arg === 'disabled') {
            vnode.elm.setAttribute('disabled', true);
          }
        }

      }
    });

    Vue.prototype.$can = function (permission) {
      let hasPermission = Store.getters['currentUser/hasPermission'](permission);
      return hasPermission;
    }
    Vue.prototype.$canAny = function (permissions) {
      let result = false;
      permissions.forEach((permission) => {
        let hasPermission = Store.getters['currentUser/hasPermission'](permission);
        result = result || hasPermission;
      })
      return result;
    }
    Vue.prototype.$canNot = function (permission) {
      let hasPermission = Store.getters['currentUser/hasPermission'](permission);
      return !hasPermission;
    }
  }
};